// TODO: Add a schema helper class to deconstruct the dto into the data/attributes field
import { z } from 'zod';

export class WordReplacementRequest {
  static schema = z.object({
    inputWord: z.string(),
    suggestions: z.array(z.string()),
    chosenSuggestion: z.string(),
    timestamp: z.date(),
  });

  lookupWord: string;
  suggestions: string[];
  chosenSuggestion: string;
  timestamp: Date;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(dto: any) {
    this.lookupWord = dto.attributes.lookupWord;
    this.suggestions = dto.attributes.suggestions;
    this.chosenSuggestion = dto.attributes.chosenSuggestion;
    this.timestamp = dto.attributes.timestamp;
  }
}
